import { Box, Slider, styled, Typography } from "@mui/material";
import MuiInput from "@mui/material/Input";
import { useEffect, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";
import Grid from "@mui/material/Grid2";

function valuetext(value) {
  return `${value}`;
}

const Input = styled(MuiInput)`
  min-width: 42px !important;
  width: 42px !important;
`;

const Slankjuoste = ({
  min,
  max,
  label,
  numatytoji,
  marksSmallScreen,
  marksBigScreen,
  zingsnis,
  changeValue,
  pavadinimas,
}) => {
  const [value, setValue] = useState(numatytoji);
  const [inputValue, setInputValue] = useState(numatytoji);
  const [marks, setMarks] = useState(marksBigScreen);

  useEffect(() => {
    const updateLegendPosition = () => {
      if (window.innerWidth < 650) {
        setMarks(marksSmallScreen);
      } else {
        setMarks(marksBigScreen);
      }
    };

    updateLegendPosition(); // Set initial state
    window.addEventListener("resize", updateLegendPosition);

    return () => window.removeEventListener("resize", updateLegendPosition);
  }, []);

  // Debounce slider value to prevent constant updates while dragging
  const debouncedSliderValue = useDebounce(value, 500);

  // Debounce input value separately
  const debouncedInputValue = useDebounce(inputValue, 500);

  // Update parent state when slider value changes (after debounce)
  useEffect(() => {
    changeValue(debouncedSliderValue);
  }, [debouncedSliderValue, changeValue]);

  // Handle input value changes (after debounce)
  useEffect(() => {
    // Only update if the values are different
    if (debouncedInputValue !== value) {
      setValue(debouncedInputValue);
      // No need to call changeValue here as it will be triggered by the other effect
    }
  }, [debouncedInputValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setInputValue(newValue);
    // Don't call changeValue here - let the debounced effect handle it
  };

  const handleInputChange = (event) => {
    setInputValue(event.target.value === "" ? "" : Number(event.target.value));
    // Set input value without validation (validation happens on blur)
  };

  const handleBlur = () => {
    let newValue = Number(inputValue);
    if (isNaN(newValue) || inputValue === "") {
      newValue = min;
    } else if (newValue < min) {
      newValue = min;
    } else if (newValue > max) {
      newValue = max;
    }

    // Update both local state and input value
    setValue(newValue);
    setInputValue(newValue);
    // Immediately update parent to ensure consistency
    changeValue(newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginTop: "-10px",
        width: "100%",
        height: "100%",
      }}
    >
      <Typography>{pavadinimas}</Typography>
      <Grid key="slanjuostesGridas" container columns={16} spacing={1}>
        <Grid
          key="slankjuostes juosta"
          size={{ xs: 14, md: 14, lg: 14, xl: 15 }}
          order={{ xs: 1, md: 1, lg: 1, xl: 1 }}
        >
          <Box display="flex" justifyContent="center" marginLeft={2} marginRight={1}>
            <Slider
              getAriaLabel={() => label}
              value={value}
              defaultValue={numatytoji}
              onChange={handleChange}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              min={min}
              max={max}
              marks={marks}
              step={zingsnis}
            />
          </Box>
        </Grid>
        <Grid
          key="rankinisIvedimas"
          size={{ xs: 2, md: 2, lg: 2, xl: 1 }}
          order={{ xs: 2, md: 2, lg: 2, xl: 2 }}
        >
          <Box display="flex" justifyContent="flex-end">
            <Input
              value={inputValue}
              size="small"
              onChange={handleInputChange}
              onBlur={handleBlur}
              inputProps={{
                step: zingsnis,
                min: min,
                max: max,
                type: "number",
                "aria-labelledby": "input-slider",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default Slankjuoste;
